const createHtmlRenderState = () => ({
    style: {},
    transform: {},
    transformOrigin: {},
    vars: {},
});

export { createHtmlRenderState };
//# sourceMappingURL=create-render-state.mjs.map
